module.exports = __webpack_public_path__ + "img/search.49e5f827.svg";